import * as DKFDS from 'dkfds';
import $ from 'jquery';
import { fdsReset, fdsShowFieldError } from '../modals';

function copyVehicle() {
    const txtTitle = $('input[name="copyTitleText"]');
    const button = $('#copyVehicleModalOK');
    if (txtTitle.val().trim().length === 0) {
        fdsShowFieldError(txtTitle, 'Du skal angive en titel.')
        $(button).prop('disabled', false);
    } else {
        button.prop('disabled', true);
        $('#copyVehicleLoading').show();
        $('form').append("<input type='hidden' name='copy' value='1'>").submit();
    }
}

function onClick() {
    const vehiclesCount = $('input:checked[name=selectedVehicle]').length;
    if (vehiclesCount === 0) {
        new DKFDS.Toast(document.getElementById('copyVehicleError')).show();
    } else if(vehiclesCount > 1) {
        new DKFDS.Toast(document.getElementById('copyOneVehicleError')).show();
    } else {
        new DKFDS.Modal(document.getElementById('copyVehicleModal')).show();
    }
}

$(() => {
    const $modal = $('#copyVehicleModal');

    $modal.get(0).addEventListener('fds.modal.hidden', () => {
        fdsReset($modal);
    });

    $('#btnCopyVehicleModal').on('click', onClick);
    $('#copyVehicleModalOK').on('click', copyVehicle);
});